// extracted by mini-css-extract-plugin
export default {"ButtonGroup":"add-comment-module__ButtonGroup--a8XKf","CommentBox":"add-comment-module__CommentBox--ICi4L"};